import { Editor, Range, Element as SlateElement, Point, Transforms } from 'slate'

export function withCheckboxListItems (editor) {
  const { deleteBackward } = editor

  editor.deleteBackward = (...args) => {
    const { selection } = editor
    const isCollapsed = selection && Range.isCollapsed(selection)

    if (!isCollapsed) {
      deleteBackward(...args)
      return
    }

    const [ match ] = Editor.nodes(editor, {
      match: node =>
        !Editor.isEditor(node) &&
        SlateElement.isElement(node) &&
        node.type === 'checkbox-list-item'
    })

    if (!match) {
      deleteBackward(...args)
      return
    }

    const [ , path ] = match
    const start = Editor.start(editor, path)

    if (!Point.equals(selection.anchor, start)) {
      deleteBackward(...args)
      return
    }

    Transforms.setNodes(
      editor,
      {
        type: 'paragraph'
      },
      {
        match: node =>
          !Editor.isEditor(node) &&
          SlateElement.isElement(node) &&
          node.type === 'checkbox-list-item'
      }
    )
  }

  return editor
}
